import {Component, inject, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {GlobalMessageService, TranslatePipe} from '@spartacus/core';
import {GlobalMessageComponent} from '@spartacus/storefront';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'dcp-global-message',
  templateUrl: './global-message.component.html',
  styleUrl: './global-message.component.scss',
  imports: [AsyncPipe, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpGlobalMessageComponent extends GlobalMessageComponent {
  constructor() {
    super(inject(GlobalMessageService));
  }
}
